/**
 * Chip / ChipRow — v2 filter chips.
 *
 * Mono uppercase pill, ember-wash when active, hairline paper when idle.
 * Replaces the legacy `filter-chips` / `chip` markup on the train screens.
 */
import type { CSSProperties, ReactNode } from 'react';

interface ChipProps {
  active?: boolean;
  disabled?: boolean;
  onClick?: () => void;
  children: ReactNode;
}

export function Chip({ active = false, disabled = false, onClick, children }: ChipProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      style={{
        padding: '7px 12px',
        borderRadius: 'var(--r-full)',
        cursor: disabled ? 'default' : 'pointer',
        fontFamily: 'var(--font-mono)',
        fontSize: 11,
        fontWeight: 500,
        letterSpacing: '0.06em',
        textTransform: 'uppercase',
        background: active ? 'var(--ember-wash)' : 'var(--paper-2)',
        border: `1px solid ${
          active ? 'color-mix(in srgb, var(--ember) 40%, transparent)' : 'var(--edge)'
        }`,
        color: active ? 'var(--ember)' : 'var(--ink-2)',
        opacity: disabled ? 0.5 : 1,
        transition:
          'background var(--t-state) var(--ease-out), color var(--t-state) var(--ease-out)',
      }}
    >
      {children}
    </button>
  );
}

export function ChipRow({ children, style }: { children: ReactNode; style?: CSSProperties }) {
  return <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, ...style }}>{children}</div>;
}
